<template>
  <div>
    <div class="row">
      <div class="col-11">
        <SectionTitle
          icon="fas fa-info-circle"
          content="Comunicación"
          container-class="tag-badge mt-5 mb-4"
        />
      </div>
      <div v-if="canDelete && !disabled" class="col-1 d-flex justify-content-end align-items-center">
        <action-button
          i="far fa-times pointer icon-right color-primary-3 font-28"
          class="px-1 mr-2 "
          @click="$emit('delete')"
        />
      </div>
    </div>

    <div class="d-flex flex-column">
      <div class="question-element">
        <div class="item-pane color-secondary-6">
          <div class="question-line col py-3 p-0">
            <b class="mb-0">
              El estudiante es sordo y utiliza el lenguaje de señas como medio principal de comunicación.
            </b>
          </div>
          <div class="align-items-end d-flex p-0 custom-radio-container">
            <validation-provider
              immediate
              v-slot="{ errors }"
              :rules="validable ? 'required' : ''"
            >
              <CustomRadioBorder
                label=""
                is-question-list
                id="diapersRequired"
                name="diapersRequired"
                class="radio-button-container"
                v-model="model.diapersRequired"
                :change-event="updateDiapersSelection"
                :options="diaperOptions"
                custom-error-msg="Favor de seleccionar Si o No."
                :error="Boolean(errors[0])"
                :disabled="disabled"
              />
            </validation-provider>
          </div>
        </div>
      </div>

      <div class="question-element">
        <div class="item-pane color-secondary-6">
          <div class="question-line col py-3 p-0">
            <b class="mb-0">
              El estudiante con limitación severa en el lenguaje expresivo que utilice el lenguaje de señas como medio principal de comunicación.
            </b>
          </div>
          <div class="align-items-end d-flex p-0 custom-radio-container">
            <validation-provider
              immediate
              v-slot="{ errors }"
              :rules="validable? 'required' : ''"
            >
              <CustomRadioBorder
                label=""
                is-question-list
                id="severelyLimitedLanguageRequired"
                name="severelyLimitedLanguageRequired"
                class="radio-button-container"
                v-model="model.severelyLimitedLanguageRequired"
                :change-event="updateSeverelyLimitedLanguageSelection"
                :options="severelyLimitedLanguageOptions"
                custom-error-msg="Favor de seleccionar Si o No."
                :error="Boolean(errors[0])"
                :disabled="disabled"
              />
            </validation-provider>
          </div>
        </div>
      </div>

      <div
        v-if="!!model.severelyLimitedLanguageRequired"
        class="row mt-3"
      >
        <validation-provider
          immediate
          v-slot="{ errors }"
          :rules="validable ? 'required' : ''"
        >
          <custom-radio
            label="Nivel de dominio:"
            is-inline
            id="domainLevel"
            name="domainLevel"
            class="radio-button-container"
            v-model="limitationDomainLevel"
            :change-event="updateLimitationDomainLevelSelection"
            :options="innerLimitationDomainLevelOptions"
            custom-error-msg="Favor de seleccionar una alternativa."
            :error="Boolean(errors[0])"
            :is-disabled="disabled"
          />
        </validation-provider>
      </div>

      <div class="mt-4 pb-4 pr-2">
        <div>Comentarios Adicionales:</div>
        <CustomTextArea
          id="commentarycomments"
          v-model="model.comment"
          class="mt-2"
          :placeholder="'Escriba un comentario'"
          :maxlength="3000"
          show-char-count
          :count-classes="['d-block text-right']"
          :rows="5"
          :disabled="disabled"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { SectionTitle } from "@/components/pei/shared";
import CustomRadioBorder from '@/components/common/CustomRadioBorder';
import CustomTextArea from "CustomTextArea";
import ActionButton from "ActionButton";
import CustomRadio from "custom-radio";
export default {
  name: "Communication",
  components: {
    SectionTitle,
    CustomRadio,
    CustomTextArea,
    CustomRadioBorder,
    ActionButton
  },
  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({
        comment: null,
        diapersRequired: null,
        severelyLimitedLanguageRequired: null,
        limitationDomainLevel: null,
      }),
    },
    validable: {
      type: Boolean,
      default: false
    },
    canDelete: {
      type: Boolean,
      default: false
    },
    limitationDomainLevelOptions: {
      type: Array,
      required: true,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      diaperOptions: [
        { label: "SI", value: true, check: false },
        { label: "NO", value: false, check: false },
      ],
      severelyLimitedLanguageOptions: [
        { label: "SI", value: true, check: false },
        { label: "NO", value: false, check: false },
      ],
      model: {
        comment: null,
        diapersRequired: null,
        severelyLimitedLanguageRequired: null,
        limitationDomainLevel: null,
      },
      limitationDomainLevel: null,
    };
  },
  computed: {
    innerLimitationDomainLevelOptions() {
      return this.limitationDomainLevelOptions.map(x => ({
        label: x.label,
        value: `${x.value}`,
        check: this.limitationDomainLevel == `${x.value}`
      }));
    },
  },
  methods: {
    updateDiapersSelection(option) {
      this.model.diapersRequired = option.value;
    },
    updateSeverelyLimitedLanguageSelection(option) {
      this.model.severelyLimitedLanguageRequired = option.value;
      this.model.limitationDomainLevel = null;
      this.limitationDomainLevel = null;
    },
    updateLimitationDomainLevelSelection(option) {
      this.model.limitationDomainLevel = parseInt(option.value);
    },
    markSelectionAsChecked(data) {
      let diaperOptionSelected = this.diaperOptions.find(x => x.value == data.diapersRequired);
      if (diaperOptionSelected) diaperOptionSelected.check = true;

      let severelyLimitedLanguageOptionSelected = this.severelyLimitedLanguageOptions.find(x => x.value == data.severelyLimitedLanguageRequired);
      if (severelyLimitedLanguageOptionSelected) severelyLimitedLanguageOptionSelected.check = true;

      let limitationDomainLevelSelected = this.limitationDomainLevelOptions.find(x => x.value == data.limitationDomainLevel);
      this.limitationDomainLevel = `${limitationDomainLevelSelected.value}`;
      if (limitationDomainLevelSelected) limitationDomainLevelSelected.check = true;
    },
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(newValue) {
        Object.assign(this.model, newValue);
        this.markSelectionAsChecked(newValue);
      }
    },
    model: {
      deep: true,
      handler(newValue) {
        this.$emit('input', newValue);
      }
    },
  }
};
</script>


<style scoped>
.item-pane {
  justify-content: space-between;
  min-width: 50%;
  margin-top: 10px;
  display: flex;
  border-bottom: solid 1px #e2e2e2;
}

.question-line p {
  padding-bottom: 0px;
}

.question-line p >>> p {
  margin-bottom: 0px !important;
}

.radio-button-container >>> .cr-icon {
  opacity: 1 !important;
}
</style>

